import React from 'react'

import { Checkbox, CheckboxProps } from '../forms/checkbox/checkbox.js'
import { Textfield, TextfieldProps } from '../forms/textfield/textfield.js'

export interface CreditCheckProps {
    title: string
    subtitle: string
    personalNumberField: TextfieldProps
    termsCheckbox: CheckboxProps
}

export const CreditCheckStep = (props: CreditCheckProps): JSX.Element => (
    <div className="text">
        <h3>{props.title}</h3>
        <p>{props.subtitle}</p>
        <Textfield {...props.personalNumberField} />
        <Checkbox {...props.termsCheckbox} />
    </div>
)
